import React, { CSSProperties } from 'react';
import { colors } from '../colors';
import { View } from './View';

export const LoadingIndicator = () => {
  const containerStyle: CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100vh',
    position: 'fixed',
    top: 0,
    left: 0,
  };

  const spinnerStyle: CSSProperties = {
    border: '4px solid rgba(0, 0, 0, 0.1)',
    borderLeft: `4px solid ${colors.brown_font}`,
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    animation: 'spin 1s linear infinite',
  };

  return (
    <View style={containerStyle}>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <div style={spinnerStyle}></div>
    </View>
  );
};
